<template>
    <div class="login-warp">
        <img class="logo" src="~@/assets/images/login/logo.png" alt="">
        <div class="code-box">
            <div class="title">A.O.史密斯企业微信登录</div>
            <div class="code" id="code_img"></div>
        </div>
    </div>
</template>

<script>

import {getWechatQroauth} from "@/js/project/v3";

export default {
    name: "projectLogin",
    data() {
        return {
            wwLogin: null
        }
    },
    created() {
        console.log(this.$router, 'this.$router')
        const auth = this.$common.getQueryString("auth");
        if (auth) {
            this.pageInit();
        } else {
            this.getConfig();
        }
    },
    methods: {
        pageInit() {
            let qyLoginCallback = this.$storage.getStorage('qy_login_callback');
            console.log(qyLoginCallback,'qyLoginCallback')
            if (qyLoginCallback) {
                this.$storage.removeStorage('qy_login_callback');
                this.$router.replace(qyLoginCallback);
            } else {
                this.$router.replace("/project/v3/case/index");
            }
        },
        getConfig() {
            let URL = window.location.protocol + "//" + document.domain + "/project/v3/login/index?auth=true";
            getWechatQroauth({from: "project-v3", callbackURL: encodeURIComponent(URL)}).then(res => {
                let data = res.data.data.result;
                if (data.user_id) {
                    this.pageInit();
                } else {
                    this.wwLogin = new WwLogin({
                        "id": "code_img",
                        "appid": data.appid,
                        "agentid": data.agentid,
                        "redirect_uri": encodeURIComponent(data.redirect_uri),
                        "href": "data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDE1MHB4O30NCi5pbXBvd2VyQm94IC50aXRsZSB7ZGlzcGxheTogbm9uZTt9DQouaW1wb3dlckJveCAuaW5mbyB7d2lkdGg6IDIwMHB4O30NCi5zdGF0dXNfaWNvbiB7ZGlzcGxheTogbm9uZSAgIWltcG9ydGFudH0NCi5pbXBvd2VyQm94IC5zdGF0dXMge3RleHQtYWxpZ246IGNlbnRlcjt9IA0KI3d4X2RlZmF1bHRfdGlwIHA6bnRoLWNoaWxkKDIpIHsNCiAgICBkaXNwbGF5OiBub25lOw0KfQ0KDQppZnJhbWUgew0KICAgIGRpc3BsYXk6IGZsZXg7DQogICAgYWxpZ24taXRlbXM6IGNlbnRlcjsNCiAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjsNCn0NCg0KLndycF9jb2RlX3JsX21hc2sgew0KICAgIHdpZHRoOiAxNTBweDsNCiAgICBtYXJnaW46IDAgYXV0bzsNCn0NCi5wYW5lbENvbnRlbnQgew0KICAgIGRpc3BsYXk6IGZsZXg7DQogICAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjsNCiAgICBoZWlnaHQ6IDI4MHB4Ow0KICAgIGp1c3RpZnktY29udGVudDogc3BhY2UtZXZlbmx5Ow0KfQ0KLndycF9jb2RlIHsNCiAgICBoZWlnaHQ6IDE1MHB4Ow0KfQ0KLmluZm8gew0KICAgIGhlaWdodDogMTNweDsNCn0NCi5pbXBvd2VyQm94IC5zdGF0dXMgew0KICAgIG1hcmdpbi10b3A6IDA7DQp9DQoNCi53cnBfY29kZV9pZnJhbWUgew0KICAgIG1hcmdpbi10b3A6IDA7DQp9"
                    });
                }
            });
        },
    }
}
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
